import { Root, Indicator } from "@radix-ui/react-progress";
import { styled } from "@styles";

export const Wrapper = styled(Root, {
  position: "relative",

  borderRadius: "$sm",
  background: "$content-3",

  overflow: "hidden",

  transform: "translateZ(0)",

  width: "$300px",
  height: "$10px",

  variants: {
    variant: {
      level: {
        background: "$neutral20",

        width: "100%",
        height: "$8px",

        padding: "$2px",
      },
    },
  },
});

export const ProgressBar = styled(Indicator, {
  width: "100%",
  height: "100%",

  background: "$blue90",
  borderRadius: "$sm",

  transition: "width 0.5s",

  variants: {
    variant: {
      level: {
        background: "$blue40",
      },
    },
  },
});
